import React from 'react';

const CircledExclamation = ({ color, size }: { color: string; size: number }) => (
  <svg viewBox={'0 0 15 15'} fill={'#fff'} width={size} height={size}>
    <path
      d="M7.41176 14.8235C11.5052 14.8235 14.8235 11.5052 14.8235 7.41176C14.8235 3.31836 11.5052 0 7.41176 0C3.31836 0 0 3.31836 0 7.41176C0 11.5052 3.31836 14.8235 7.41176 14.8235Z"
      fill={color}
    />
    <path
      d="M7.4123 8.89406C7.14389 8.89405 6.8859 8.79017 6.69236 8.6042C6.49883 8.41822 6.38477 8.16456 6.37407 7.89637L6.23713 4.43832C6.23163 4.29854 6.25442 4.15909 6.30412 4.02833C6.35382 3.89757 6.42941 3.77819 6.52636 3.67734C6.6233 3.5765 6.73962 3.49627 6.86832 3.44147C6.99702 3.38666 7.13547 3.35841 7.27536 3.3584H7.54924C7.68913 3.35841 7.82758 3.38666 7.95628 3.44147C8.08498 3.49627 8.2013 3.5765 8.29825 3.67734C8.3952 3.77819 8.47078 3.89757 8.52048 4.02833C8.57018 4.15909 8.59297 4.29854 8.58747 4.43832L8.45053 7.89637C8.43983 8.16456 8.32577 8.41822 8.13224 8.6042C7.9387 8.79017 7.68071 8.89405 7.4123 8.89406Z"
      fill="white"
    />
    <path
      d="M8.44874 10.4277C8.44874 9.85482 7.9843 9.39038 7.41138 9.39038C6.83846 9.39038 6.37402 9.85482 6.37402 10.4277C6.37402 11.0007 6.83846 11.4651 7.41138 11.4651C7.9843 11.4651 8.44874 11.0007 8.44874 10.4277Z"
      fill="white"
    />
  </svg>
);

export default CircledExclamation;
